import { Time } from '@internationalized/date';
import {
  DateInput,
  DateSegment,
  FieldError,
  Label,
  Text,
  TimeField,
  TimeValue,
  ValidationResult,
} from 'react-aria-components';

type TimePickerProps = {
  onChange: (time: TimeValue) => void;
  label?: string;
  hours: number;
  minutes: number;
  description?: string;
  errorMessage?: string | ((validation: ValidationResult) => string);
};
export const TimePicker = (props: TimePickerProps) => {
  const { onChange, label, hours, minutes, description, errorMessage } = props;

  return (
    <TimeField value={new Time(hours, minutes)} onChange={onChange}>
      {label && <Label>{label}</Label>}
      <DateInput className='flex flex-row border border-gray-400 rounded-md w-36 p-3'>
        {(segment) => (
          <DateSegment className={segment.type === 'dayPeriod' ? 'px-1' : ''} segment={segment} />
        )}
      </DateInput>
      {description && <Text slot='description'>{description}</Text>}
      <FieldError>{errorMessage}</FieldError>
    </TimeField>
  );
};
